export default __webpack_public_path__ + "static/media/skin.3fefc178.png";